import { render } from "./NotificationsPage.vue?vue&type=template&id=0b7f3ea0"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"
script.render = render

export default script